<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="licenciaForm">
          <v-row>
            <v-col cols="4">
              <BaseInput v-model="licenciaOficialColectiva.noLicencia" label="N. Licencia" readonly />
            </v-col>
            <v-col cols="4">
              <BaseInput
                v-model="licenciaOficialColectiva.fechaAlta"
                label="Fecha alta"
                hint="Formato de fecha: DD/MM/YYYY"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <BaseInput
                v-model="licenciaOficialColectiva.fechaTramite"
                label="Fecha tramite"
                hint="Formato de fecha: DD/MM/YYYY"
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                rounded
                filled
                dense
                rows="3"
                color="secondary"
                background-color="primary"
                v-model="licenciaOficialColectiva.direccion"
                label="Dirección"
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                rounded
                filled
                dense
                rows="3"
                color="secondary"
                background-color="primary"
                v-model="licenciaOficialColectiva.nombreInstancia"
                label="Nombre instancia"
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                rounded
                filled
                dense
                rows="3"
                color="secondary"
                background-color="primary"
                v-model="licenciaOficialColectiva.titular"
                label="Titular"
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                rounded
                filled
                dense
                rows="3"
                color="secondary"
                background-color="primary"
                v-model="licenciaOficialColectiva.representanteLegal"
                label="Representante legal"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <BaseInput v-model="licenciaOficialColectiva.rm" label="RM" readonly />
            </v-col>

            <v-col cols="4">
              <BaseInput v-model="licenciaOficialColectiva.vigencia" label="Vigencia" readonly />
            </v-col>
            <v-col cols="4">
              <BaseInput v-model="licenciaOficialColectiva.zm" label="ZM" readonly />
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'

export default {
  components: {
    BaseInput,
  },
  computed: {
    ...mapGetters('licenciaOficialColectiva', {
      licenciaOficialColectiva: 'getSelectedLoc',
    }),
  },
  data() {
    return {
      licenciaForm: false,
    }
  },
}
</script>
